<template>
<FormSelect v-if="localizationOptions?.length" :options="localizationOptions" v-model="value" :optional="true" />
</template>
<script>
export default {
  props: ["modelValue", "localization"],
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    localizationOptions() {
      var opts=[];
      for(var locale in this.stores.auth?.localizations?.[this.localization] || {}) {
        var localeProps=this.stores.auth.localizations[this.localization][locale];
        opts.push({
          value: locale,
          text: localeProps.name || locale,
        });
      }
      return opts;
    },
  },
}
</script>
